import React from 'react';

import CampaignActions from './components/CampaignActions';
import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import EmptyState from 'src/presentation/components/pages/proactiveCommunications/components/shared/EmptyState';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import ProactiveCommunication from 'src/presentation/components/pages/proactiveCommunications/components/ProactiveCommunications';

const ProactiveSms = ({ root }) => {
  const description = (
    <span>
      Proactively reach out to your customers through automated text messages. Visit our{' '}
      <ExternalLink
        data-aid="set-up-proactive-sms-help-link"
        label="Help Docs"
        to="https://help.gladly.com/docs/what-is-proactive-sms"
      />{' '}
      to learn more about SMS Campaigns.
    </span>
  );

  const actions = <CampaignActions root={root} />;
  const emptyStateRender = <EmptyState title="Create your first Proactive SMS Campaign" actionsRender={actions} />;

  return (
    <ProactiveCommunication
      actionsRender={actions}
      campaignType={CampaignType.SMS}
      description={description}
      header="Proactive SMS"
      root={root}
      emptyStateRender={emptyStateRender}
    />
  );
};

export default ProactiveSms;
